import React from "react";

interface U2000IdCheckedBoxDisplayProps {
  column: any;
  value: any;
  row: Record<string, any>;
  disabled: boolean;
  rowUpdated?: (row: any) => void;
  allowRowSelection?: boolean;
}

export const U2000IdCheckedBoxDisplay: React.FC<U2000IdCheckedBoxDisplayProps> = ({ row, disabled, rowUpdated, allowRowSelection = true }) => {
  const handleChange = (e: boolean) => {
    if (disabled || !allowRowSelection) return;
    row["idChecked"] = e;
    if (rowUpdated) {
      rowUpdated(row);
    }
  };

  const checked: boolean = row["idChecked"] || false;

  return (
    <div className="flex h-full items-center justify-center">
      <div
        className={`h-6 w-6 rounded-sm border-2 transition-colors duration-300 ${!disabled ? (allowRowSelection ? "border-gray-500" : "border-gray-300") : "border-gray-400"}`}
        onClick={() => handleChange(!checked)}
        style={{ cursor: disabled || !allowRowSelection ? "not-allowed" : "pointer" }}
      >
        {checked ? (
          <svg className="m-auto h-5 w-5 text-black" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
            <path d="M5 13l4 4L19 7" />
          </svg>
        ) : (
          // SVG invisible pour garder la même taille
          <svg className="m-auto h-5 w-5" style={{ visibility: "hidden" }} viewBox="0 0 24 24">
            <path d="M5 13l4 4L19 7" />
          </svg>
        )}
      </div>
    </div>
  );
};
